import React from 'react';
import PropTypes from 'prop-types';

const DelimiterRow = ({
    raceDatetime,
    daysBreak,
}) => (
    <tr
        className="ui-table__row hp-formTable__delimiter"
        key={raceDatetime}
    >
        <td
            className="ui-table__cell hp-formTable__delimiterCell"
            colSpan={11}
        >
            <span className="hp-formTable__delimiterLine" />
            <span className="hp-formTable__delimiterText">
                { daysBreak } days break
            </span>
        </td>
    </tr>
);


DelimiterRow.propTypes = {
    raceDatetime: PropTypes.string,
    daysBreak: PropTypes.number,
};

export default DelimiterRow;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/DelimiterRow.jsx